module.exports = __webpack_public_path__ + "static/img/search_subcat_item_07_show.453e7ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_07_show.jpg
// module id = vMgJ
// module chunks = 0